// kezzel kell atirni!
export const version = '1.0.40';
